export const SET_SELECTED_VALUES = (prefix) =>
  `${prefix}_FILTER_SET_SELECTED_VALUES`;
export const RESET_SELECTED_VALUES = (prefix) =>
  `${prefix}_FILTER_RESET_SELECTED_VALUES`;
export const SET_AVAILABLE_VALUES = (prefix) =>
  `${prefix}_FILTER_SET_AVAILABLE_VALUES`;
